import { createContext, useContext, type ReactNode } from "react"

/**
 * The results table's selection-scoped actions, published to the run-level
 * actions the table renders in its controls row. Those actions arrive as a
 * `tableActions` node but render inside the table's tree, so the run's
 * overflow menu can host the delete that acts on the table's selection
 * instead of opening a second menu beside it.
 */
interface RunResultsSelectionActions {
  isDeletingSelected: boolean
  onDeleteSelected: () => void
  selectedCount: number
}

const RunResultsSelectionActionsContext =
  createContext<RunResultsSelectionActions | null>(null)

export const RunResultsSelectionActionsProvider = ({
  children,
  value,
}: {
  children: ReactNode
  value: RunResultsSelectionActions
}) => (
  <RunResultsSelectionActionsContext.Provider value={value}>
    {children}
  </RunResultsSelectionActionsContext.Provider>
)

/**
 * Null when the actions render outside a results table, which is what tells a
 * caller to keep its own run-level delete rather than retargeting it.
 */
export const useRunResultsSelectionActions = () =>
  useContext(RunResultsSelectionActionsContext)
